module.exports = __webpack_public_path__ + "img/mondays-not-coming.563e1fc1.png";